<template>
  <!-- 发布排名 -->
  <div class="wlmq-newWX-container">
    <div class="header">
<!--      <img-->
<!--        src="../../../assets/Uram/Releaseranking/articleLogo_02.png"-->
<!--        alt=""-->
<!--      />-->
      <div class="bodyTitle">
        <span class="title">{{ newWxTitle }}</span>
        <!-- <el-select
          v-model="value"
          :placeholder="groupName"
          @change="searchByAccount"
        >
          <el-option
            v-for="item in wxAccountList"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select> -->
      </div>
      <div class="showDate">
        <span class="nowDate">
          {{ today }}
        </span>
        <span class="nowWeek">
          {{ nowDay }}
        </span>
      </div>
    </div>
    <transition
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutLeft"
    >
      <div class="newWX-main" v-show="show">
        <div class="body-left">
          <div class="tHeader">
            <span class="s1">排行</span>
            <span class="s2">名称</span>
            <span class="s3">DCI</span>
            <span class="s4">总点赞数</span>
            <span class="s5">总评论数</span>
          </div>
          <div class="tBody" v-if="options.length > 0">
            <div
              class="concernList"
              v-for="item in options2"
              :key="item.id_key"
              :class="item.id_key == activeIndex ? 'active' : ''"
            >
              <div class="mainContent" @click="chooseList(item, item.id_key)">
                <span class="s1">
                  <div v-if="item.id_key == 0" class="container first">
                    {{ item.id_key + 1 }}
                  </div>
                  <div v-if="item.id_key == 1" class="container second">
                    {{ item.id_key + 1 }}
                  </div>
                  <div v-if="item.id_key == 2" class="container third">
                    {{ item.id_key + 1 }}
                  </div>
                  <div
                    v-if="
                      item.id_key != 0 && item.id_key != 1 && item.id_key != 2
                    "
                    class="container"
                  >
                    {{ item.id_key + 1 }}
                  </div>
                </span>
                <span class="s2">
                  <img :src="item.iconLocal" v-if="item.icon" />
                  <span>{{ item.sourceName }}</span>
                </span>
                <span class="s3">{{ item.dci }}</span>
                <span class="s4">{{ item.totalLikes }}</span>
                <span class="s5">{{ item.totalComment }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="body-right">
          <div class="main-title">{{ sourceName }}</div>
          <!-- <div class="wx-title">
            {{ wxTitle }}
          </div> -->
          <div class="echarts" id="echarts-line"></div>
          <div class="echarts" id="echarts-bar"></div>
          <el-radio-group
            class="choose-date"
            v-model="radio"
            @change="chooseDays"
          >
            <el-radio label="15d">近15天</el-radio>
            <el-radio label="30d">近30天</el-radio>
          </el-radio-group>
        </div>
      </div>
    </transition>
    <!-- <transition
      enter-active-class="animated bounceInRight"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-main" v-if="show2">
        <div class="back">
          <div class="back-icon" @click="back">
            <i class="iconfont icon-fanhui1"></i>
          </div>
        </div>
        <div class="body">
          <div class="tHeader">
            <span class="s1">排行</span>
            <span class="s2">名称</span>
            <span class="s3">WCI</span>
            <span class="s4">点赞数</span>
            <span class="s5">阅读数</span>
          </div>
          <div class="tBody">
            <div
              class="concernList"
              v-for="(item, index) in options2"
              :key="index"
              :class="index == activeIndex2 ? 'active' : ''"
            >
              <div class="mainContent">
                <span class="s1">
                  <div v-if="index == 0" class="container first">
                    {{ index + 1 }}
                  </div>
                  <div v-if="index == 1" class="container second">
                    {{ index + 1 }}
                  </div>
                  <div v-if="index == 2" class="container third">
                    {{ index + 1 }}
                  </div>
                  <div
                    v-if="index != 0 && index != 1 && index != 2"
                    class="container"
                  >
                    {{ index + 1 }}
                  </div>
                </span>
                <span class="s2">
                  <span @click="detail(item, index)">{{ item.title }}</span>
                </span>
                <span class="s3">{{ item.wci }}</span>
                <span class="s4">{{ item.good }}</span>
                <span class="s5">{{ item.readcount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="list-detail" v-if="showBody.title">
          <div class="deatilDialog">
            <div class="detailHeader">
              <i class="iconfont icon-chahao" @click="closeDialog"></i>
            </div>
            <div class="detailBody">
              <div class="detailTitle">
                {{ showBody.title }}
              </div>
              <div class="detailOriginal">
                <span class="time">{{ showBody.date }}</span>
              </div>
              <div class="detailMain" v-html="showBody.content"></div>
            </div>
          </div>
        </div>
      </div>
    </transition> -->
  </div>
</template>

<script>
import echarts from "echarts";
import { timeList, getDyRanking } from "../../../api/article";
import { getDyRankingInfo } from "../../../api/UramWu/uram";
import LoginVue from "../../../views/Login.vue";
export default {
  data() {
    return {
      user: "",
      newWxTitle: "抖音媒体当日发布排名",
      show: true,
      show2: false,
      showDetail: true,
      wxAccountList: [],
      groupId: "",
      groupName: null,
      value: "",
      today: "",
      nowDay: "",
      parentId: "1",
      timeRange: "3",
      sourceName: "人民日报",
      activeIndex: 0,
      activeIndex2: 0,
      options: [],
      options2: [],
      wxTitle: "",
      echartsLine: "",
      sourceaccount: "",
      echartsBar: "",
      radio: "15d",
      interval: "",
      wxDetailImg: "",
      interval2: "",
      showBody: "",
      len: "",
    };
  },
  created() {
    if (this.$route.query.title) {
      this.newWxTitle = this.$route.query.title;
    }
    this.user = this.$store.state.nickname;
    // this.$http.get(`${this.BASE_URL.url}lsg/getUserGroupMo.jspx?scid=38&userId=${sessionStorage.user}`)
    /* 订阅分组接口 */
    timeList().then((res) => {
      this.wxAccountList = res.data.data;
      let b = this.wxAccountList.map((item) => {
        return item.name;
      });
      console.log(b, "55555");
      this.groupName = b[0];
      console.log(this.groupName, "11111");
      this.getWxList();
    });
    var self = this;
    setInterval(self.nowDate, 1000);
  },
  methods: {
    //获取当前时间
    nowDate() {
      var now = new Date();
      var day = "";
      switch (now.getDay()) {
        case 1:
          day = "一";
          break;
        case 2:
          day = "二";
          break;
        case 3:
          day = "三";
          break;
        case 4:
          day = "四";
          break;
        case 5:
          day = "五";
          break;
        case 6:
          day = "六";
          break;
        case 0:
          day = "日";
          break;
        default:
          break;
      }
      this.today =
        now.getFullYear() +
        "年" +
        (Number(now.getMonth()) + 1) +
        "月" +
        now.getDate() +
        "日";
      this.nowDay = "星期" + day;
    },
    mouseenter(item, index) {
      this.wxTitle = item.name;
      this.activeIndex = index;
      clearInterval(this.interval);
    },
    mouseleave() {
      var self = this;
      this.interval = setInterval(function() {
        if (self.activeIndex < self.options.length - 1) {
          self.activeIndex++;
        } else {
          self.activeIndex = 0;
        }
        self.wxTitle = self.options[self.activeIndex].name;
      }, 10000);
    },
    chooseList(item, index) {
      clearInterval(this.interval);
      this.wxTitle = item.name;
      this.sourceName = item.sourceName;
      this.activeIndex = index;
      // this.options2=this.options.slice(0,10)
      this.sourceaccount = item.sourceaccount;
      this.radio = "15d";
      echarts.dispose(this.echartsLine);
      echarts.dispose(this.echartsBar);
      this.echartsLine = document.getElementById("echarts-line");
      this.echartsBar = document.getElementById("echarts-bar");
      this.echartsLine = echarts.init(this.echartsLine);
      this.echartsBar = echarts.init(this.echartsBar);
      var self = this;
      this.interval = setInterval(function() {
        if (self.activeIndex < self.options.length - 1) {
          self.activeIndex++;
          if (self.activeIndex == 0) {
            self.options2 = self.options.slice(0, 10);
            console.log(self.options2, "11111111");
          } else if (self.activeIndex == 10) {
            self.options2 = self.options.slice(10, 20);
          } else if (self.activeIndex == 20) {
            self.options2 = self.options.slice(20, 30);
          } else if (self.activeIndex == 30) {
            self.options2 = self.options.slice(30, 40);
          } else if (self.activeIndex == 40) {
            self.options2 = self.options.slice(40, 50);
          } else if (self.activeIndex == 50) {
            self.options2 = self.options.slice(50, 60);
          } else if (self.activeIndex == 60) {
            self.options2 = self.options.slice(60, 70);
          }
        } else {
          self.activeIndex = 0;
          self.options2 = self.options.slice(0, 10);
        }
        self.radio = "15d";
        self.wxDetailImg = self.options[self.activeIndex].icon;
        self.wxTitle = self.options[self.activeIndex].name;
        self.chooseList(self.options[self.activeIndex], self.activeIndex);
      }, 5000);
      console.log(this.options2, "22222222");
      // this.$http.get(`${this.BASE_URL.url}lsg/wx/dimension_data_in_range.jspx?userId=${sessionStorage.user}&sourceaccount=${item.sourceaccount}&is_top=0`)

      getDyRankingInfo({
        timeRange: "15d",
        sourceName: this.sourceName,
      }).then((res) => {
        let count = res.data.data[0];
        let day = res.data.data[1];
        let date = [];
        day.forEach((item) => {
          date.push(item.substr(0, 10));
        });
        let aa = count.map((item) => {
          if (item.comment == null) {
            return (item.comment = 0);
          } else {
            return item.comment;
          }
        });
        let bb = count.map((item) => {
          if (item.like == null) {
            return (item.like = 0);
          } else {
            return item.like;
          }
        });
        let wci = res.data.data[2];
        let cc = wci.map((item) => {
          if (item == null) {
            return (item = 0);
          } else {
            return item;
          }
        });
        // this.showEcharLine(res.data.data.readCount,res.data.data.goodCount)
        this.showEcharLine(date, bb, aa);
        this.showEcharBar(date, cc);
      });
    },
    chooseDays(val) {
      if (val == "15d") {
        this.timeRange = "15d";
      } else {
        this.timeRange = "1m";
      }
      getDyRankingInfo({
        timeRange: this.timeRange,
        sourceName: this.sourceName,
      }).then((res) => {
        let count = res.data.data[0];
        let day = res.data.data[1];
        let date = [];
        day.forEach((item) => {
          date.push(item.substr(0, 10));
        });
        let aa = count.map((item) => {
          if (item.comment == null) {
            return (item.comment = 0);
          } else {
            return item.comment;
          }
        });
        let bb = count.map((item) => {
          if (item.like == null) {
            return (item.like = 0);
          } else {
            return item.like;
          }
        });
        let wci = res.data.data[2];
        let cc = wci.map((item) => {
          if (item == null) {
            return (item = 0);
          } else {
            return item;
          }
        });
        // this.showEcharLine(res.data.data.readCount,res.data.data.goodCount)
        this.showEcharLine(date, bb, aa);
        this.showEcharBar(date, cc);
      });
    },
    // detail(item, index) {
    //   this.activeIndex2 = index;
    //   clearInterval(this.interval2);
    //   // this.$http.get(`${this.BASE_URL.url}lsg/WeChatDetailsContent.jspx?reference=${item.reference}`).then((res)=>{
    //   // 	this.showBody = res.body.data.content_f[0]
    //   // })
    // },
    // back() {
    //   clearInterval(this.interval2);
    //   this.show = true;
    //   this.show2 = false;
    //   var self = this;
    //   this.interval = setInterval(function() {
    //     if (self.activeIndex < self.options.length - 1) {
    //       self.activeIndex++;
    //     } else {
    //       self.activeIndex = 0;
    //     }
    //     self.radio = "15d";
    //     self.wxDetailImg = self.options[self.activeIndex].icon;
    //     self.wxTitle = self.options[self.activeIndex].name;
    //     self.chooseList(self.options[self.activeIndex], self.activeIndex);
    //   }, 10000);
    // },
    showEcharLine(date, good, read) {
      //点赞量 1f7558
      //播放量 862c9d
      var optionLine = {
        title: {
          text: "数据统计",
          textStyle: {
            color: "#fff",
          },
          left: 20,
        },
        tooltip: {
          trigger: "axis",
        },
        color: ["#1f7558", "#862c9d"],
        legend: {
          data: ["点赞数", "评论数"],
          x: "right",
          textStyle: {
            color: "#fffeff",
            fontSize: 14,
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisLabel: {
            interval: 2,
          },
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#182b49",
            },
          },
        },
        series: [
          {
            name: "点赞数",
            type: "line",
            data: good,
            lineStyle: {
              color: "#1f7558",
            },
          },
          {
            name: "评论数",
            type: "line",
            data: read,
            lineStyle: {
              color: "#862c9d",
            },
          },
        ],
      };
      this.echartsLine.setOption(optionLine);
    },
    showEcharBar(date, WCIS) {
      //点赞量 1f7558
      //阅读量 862c9d
      var self = this;
      var optionBar = {
        title: {
          text: "DCI统计",
          textStyle: {
            color: "#fff",
          },
          left: 20,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: date,
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#182b49",
            },
          },
        },
        series: [
          {
            name: "DCI指数",
            data: WCIS,
            type: "bar",
            itemStyle: {
              color: "#00aeff",
            },
          },
        ],
      };
      this.echartsBar.setOption(optionBar);
    },
    searchByAccount(e) {
      clearInterval(this.interval2);
      this.groupName = e;
      this.getWxList();
      //   this.show = true;
      //   this.show2 = false;
      //   var self = this;
      //   this.interval = setInterval(function() {
      //     if (self.activeIndex < self.options.length - 1) {
      //       self.activeIndex++;
      //     } else {
      //       self.activeIndex = 0;
      //     }
      //     self.radio = "15d";
      //     self.wxDetailImg = self.options[self.activeIndex].icon;
      //     self.wxTitle = self.options[self.activeIndex].name;
      //     self.chooseList(self.options[self.activeIndex], self.activeIndex);
      //   }, 10000);
    },
    getWxList() {
      clearInterval(this.interval);
      getDyRanking({
        groupName: this.groupName,
        range: "1m",
      }).then((res) => {
        if (res.data.code == 200) {
          let arr = res.data.data;
          let _arr = [];
          arr.map((item, index) => {
            _arr.push(Object.assign({}, item, { id_key: index }));
          });

          this.options = _arr;
          let hefei = {}
              this.options.filter(val=>{
            if(val.sourceName==='合肥消防'){
              hefei = val
            }
          })
          this.options.splice(0,0,hefei)
          this.chooseList(this.options[0], 0);
          this.options2 = this.options.slice(0, 10);
        } else {
          this.options2 = [];
        }
      });
    },
    // mouseenter2(item, index) {
    //   this.activeIndex2 = index;
    //   clearInterval(this.interval2);
    // },
    // mouseleave2() {
    //   var self = this;
    //   this.interval2 = setInterval(function() {
    //     if (self.activeIndex2 < self.len - 1) {
    //       self.activeIndex2++;
    //     } else {
    //       self.activeIndex2 = 0;
    //     }
    //   }, 10000);
    // },
    // closeDialog() {
    //   this.showBody = "";
    //   var self = this;
    //   this.interval2 = setInterval(function() {
    //     if (self.activeIndex2 < self.len - 1) {
    //       self.activeIndex2++;
    //     } else {
    //       self.activeIndex2 = 0;
    //     }
    //   }, 10000);
    //   this.show = false;
    // },
  },
};
</script>

<style scoped lang="scss">
.wlmq-newWX-container {
  background-image: url("../../../assets/Uram/Releaseranking/expert_bg_img.jpg");
  background-size: 100% 100%;
  position: relative;
  height: 100%;
  .header {
    img {
      position: absolute;
      top: 3vh;
      left: 4%;
      width: 2.5%;
    }
    .bodyTitle {
      padding: 1.9vh 3.65% 1% 2%;
      display: flex;
      align-items: center;
      margin-left: 2%;
      .title {
        color: #fff;
        font-weight: bold;
        display: inline-block;
        width: 20.75%;
        text-align: center;
        height: 7.5vh;
        line-height: 7.5vh;
        font-size: 1.5vw;
        overflow: hidden;
      }
    }
    .showDate {
      position: absolute;
      top: 4.7vh;
      right: 3.65%;
      font-size: 0.84vw;
      .nowDate {
        color: #eff1ee;
      }
      .nowWeek {
        margin-left: 10px;
        color: #519bf0;
        position: relative;
        top: -1px;
      }
    }
  }
  .newWX-main {
    position: relative;
    margin-top: 6.2vh;
    font-size: 1.04vw;
    .body-left {
      width: 56%;
      padding: 0px 3.65% 0 3.4%;
      .tHeader {
        border: 3px solid #376fa8;
        color: #fff;
        background-color: #09153d;
        /*margin-left: 85px;*/
        line-height: 36px;
        font-size: 16px;
        span {
          display: inline-block;
        }
        .s1 {
          width: 80px;
          text-align: center;
        }
        .s2 {
          width: calc(100% - 80px - 180px - 180px - 180px - 30px - 100px);
          margin-left: 100px;
        }
        .s3 {
          width: 180px;
          text-align: center;
        }
        .s4 {
          width: 180px;
          text-align: center;
        }
        .s5 {
          width: 180px;
          text-align: center;
        }
      }
      .tBody {
        color: #fff;
        margin-top: 17px;
        .concernList {
          position: relative;
          width: 100%;
          margin-bottom: 5px;
          div {
            display: inline-block;
          }
          .mainContent {
            width: calc(100% - 6px);
            border: 3px solid #376fa8;
            border-radius: 10px;
            background-color: #09153b;
            line-height: 5.7vh;
            span {
              display: inline-block;
            }
            .s1 {
              width: 80px;
              text-align: center;
              .container {
                display: inline-block;
                width: 30px;
                height: 46px;
                line-height: 46px;
                border-radius: 4px;
                font-size: 25px;
                border: 0;
                background-color: #1b75ff;
                color: #fff;
                transform: skew(-20deg);
              }
              .first {
                background-color: #f34125;
              }
              .second {
                background-color: #ea681a;
              }
              .third {
                background-color: #ffa901;
              }
            }
            .s2 {
              width: calc(100% - 80px - 180px - 180px - 180px - 30px - 30px);
              margin-left: 30px;
              display: inline-flex;
              height: 100%;
              overflow: hidden;
              white-space: nowrap;
              align-items: center;
              vertical-align: middle;
              img {
                width: 45px;
                height: 45px;
                border: 1px solid #fff;
                border-radius: 50%;
                vertical-align: middle;
                position: relative;
                top: -3px;
              }
              span {
                margin-left: 18px;
                font-weight: bold;
                width: 250px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
            .s3 {
              width: 180px;
              text-align: center;
            }
            .s4 {
              width: 180px;
              text-align: center;
            }
            .s5 {
              width: 180px;
              text-align: center;
            }
          }
        }
        .active {
          .mainContent {
            line-height: 6.5vh;
            background-color: #0e2e91;
            box-shadow: 0px 0px 59px 20px #164595;
            .s2 {
              color: #ffcb00;
              font-size: 28px;
            }
            .s3,
            .s4,
            .s5 {
              font-size: 22px;
            }
          }
        }
      }
    }
    .body-right {
      position: absolute;
      width: calc(44% - 74px);
      top: 0px;
      right: 57px;
      background-image: url("../../../assets/Uram/Releaseranking/中国新闻网框.png");
      height: calc(57vh + 67px + 76px + 36px);
      background-size: 100% 100%;
      text-align: center;
      .main-title {
        position: absolute;
        width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #00bfff;
        line-height: 25px;
        left: 20px;
        top: 10px;
      }
      .wx-title {
        display: inline-block;
        padding: 0px 10px;
        height: 29px;
        background-color: #006cff;
        color: #fff;
        margin-top: 6px;
        line-height: 29px;
        font-size: 16px;
      }
      .echarts {
        margin: 40px 10px 0px 10px;
        width: calc(100% - 20px);
        height: calc((100% - 70px) / 2);
      }
      .choose-date {
        position: absolute;
        bottom: calc((100% - 120px) / 2);
        right: 50px;
        z-index: 99;
        color: #fff;
      }
    }
  }
  .detail-main {
    position: absolute;
    width: 100%;
    top: 94px;
    .back {
      text-align: right;
      margin-top: 30px;
      .back-icon {
        display: inline-block;
        margin-right: 3.65%;
        width: 50px;
        height: 30px;
        background-color: #0046a5;
        border-radius: 3px;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        .iconfont {
          color: #fff;
          font-size: 18px;
        }
      }
    }
    .body {
      padding: 20px 3.65% 0 3.4%;
      .tHeader {
        border: 3px solid #376fa8;
        color: #fff;
        background-color: #09153d;
        /*margin-left: 85px;*/
        line-height: 36px;
        font-size: 16px;
        span {
          display: inline-block;
        }
        .s1 {
          width: 80px;
          text-align: center;
        }
        .s2 {
          width: calc(100% - 80px - 180px - 180px - 180px - 30px - 100px);
          margin-left: 100px;
        }
        .s3 {
          width: 180px;
          text-align: center;
        }
        .s4 {
          width: 180px;
          text-align: center;
        }
        .s5 {
          width: 180px;
          text-align: center;
        }
      }
      .tBody {
        color: #fff;
        margin-top: 17px;
        font-size: 1.04vw;
        .concernList {
          position: relative;
          width: 100%;
          margin-bottom: 5px;
          div {
            display: inline-block;
          }
          .mainContent {
            display: flex;
            width: calc(100% - 6px);
            border: 3px solid #376fa8;
            border-radius: 10px;
            background-color: #09153b;
            line-height: 7.5vh;
            span {
              display: inline-block;
              margin-left: 12px;
            }
            .s1 {
              width: 80px;
              text-align: center;
              margin-left: 0px;
              .container {
                display: inline-block;
                width: 30px;
                height: 46px;
                line-height: 46px;
                border-radius: 4px;
                font-size: 25px;
                border: 0;
                background-color: #1b75ff;
                color: #fff;
                transform: skew(-20deg);
              }
              .first {
                background-color: #f34125;
              }
              .second {
                background-color: #ea681a;
              }
              .third {
                background-color: #ffa901;
              }
            }
            .s2 {
              overflow: hidden;
              white-space: nowrap;
              width: calc(100% - 80px - 180px - 180px - 180px - 30px - 30px);
              margin-left: 30px;
              img {
                width: 45px;
                height: 45px;
                border: 1px solid #fff;
                border-radius: 50%;
                vertical-align: middle;
                position: relative;
                top: -3px;
              }
              span {
                margin-left: 18px;
                font-weight: bold;
                width: 250px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
            .s3 {
              width: 180px;
              text-align: center;
            }
            .s4 {
              width: 180px;
              text-align: center;
            }
            .s5 {
              width: 180px;
              text-align: center;
            }
          }
        }
        .active {
          .mainContent {
            line-height: 6.5vh;
            background-color: #0e2e91;
            box-shadow: 0px 0px 59px 20px #164595;
            .s2 {
              color: #ffcb00;
              font-size: 28px;
            }
            .s3,
            .s4,
            .s5 {
              font-size: 22px;
            }
          }
        }
      }
    }
    .list-detail {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0px;
      .deatilDialog {
        position: absolute;
        width: 1096px;
        top: 8%;
        height: 80%;
        left: calc((100% - 1096px) / 2);
        border: 1px solid #167fff;
        color: #fff;
        background-color: #002559;
        .detailHeader {
          text-align: right;
          padding: 16px 16px;
          color: #ffffff;
          .iconfont {
            cursor: pointer;
          }
        }
        .detailBody {
          height: calc(100% - 53px);
          overflow: hidden;
          overflow-y: auto;
          .detailTitle {
            padding: 0px 86px;
            font-size: 30px;
            display: block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-weight: bold;
          }
          .detailOriginal {
            padding: 20px 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            .original {
              display: flex;
              align-items: center;
              img {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                margin-right: 10px;
              }
            }
          }
          .detailMain {
            padding: 0px 88px 0px 88px;
            margin-bottom: 72px;
            line-height: 1.5;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.wlmq-newWX-container {
  .header {
    .bodyTitle {
      .el-select {
        margin-left: 15px;
        width: 180px;
        .el-input--suffix {
          .el-input__inner {
            line-height: 33px;
            height: 33px;
            border-color: #008191;
            background-color: inherit;
            color: #02f6fe;
          }
          .el-input__suffix {
            .el-input__suffix-inner {
              .el-icon-arrow-up {
                line-height: 30px;
              }
            }
          }
        }
      }
    }
  }
  .newWX-main {
    .body-right {
      .choose-date {
        .el-radio {
          .el-radio__label {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
